// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"246":"orders-home","357":"providers-config-home","476":"provider-stores-home","728":"stores-home","771":"orders-detail","906":"status-home","968":"providers-provider","986":"providers-home"}[chunkId] || chunkId) + ".js";
};